export type ResourceType = 'google_sheet' | 'gdrive_folder' | 'url'
export type ResourceStatus = 'linked' | 'missing' | 'invalid'
export type ResourceSyncSource = 'register' | 'manual'

export interface FranchisePartnerResource {
  resource_code: string
  resource_type: ResourceType
  label: string
  description: string
  register_eligible: boolean
  resource_id: string | null
  // ``resource_url`` is the raw value stored on the row (rare - only set when
  // an admin pasted a full URL instead of an ID). ``url`` is the resolved
  // link the UI actually opens, derived server-side from resource_id via the
  // catalog url_template, or falling back to resource_url. UI code should
  // always read ``url``; ``resource_url`` is exposed for completeness so the
  // form can round-trip the stored value.
  resource_url?: string | null
  url: string | null
  status: ResourceStatus
  meta?: Record<string, unknown> | null
  last_synced_at?: string | null
  last_sync_source?: ResourceSyncSource | null
  last_checked_at?: string | null
}

export interface ResourceCatalogEntry {
  resource_code: string
  label: string
  description: string
  resource_type: ResourceType
  register_eligible: boolean
}

export function getResource(
  resources: FranchisePartnerResource[] | null | undefined,
  resourceCode: string,
): FranchisePartnerResource | undefined {
  return resources?.find(r => r.resource_code === resourceCode)
}
